/* eslint-disable */
/// This file is auto generated - do not edit manually
export const FewInStock = 'Website.ProductStoreSearch.ProductStock.FewInStock';
export const SoldOut = 'Website.ProductStoreSearch.ProductStock.SoldOut';
export const IsInStock = 'Website.ProductStoreSearch.ProductStock.IsInStock';
export const UnknownStock = 'Website.ProductStoreSearch.ProductStock.UnknownStock';
